// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../dist/img/lib.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- General ---------- */
body {
  font-family: BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  background-color: var(--background_color_mob);
}
@media (min-width: 768px) {
  body {
    background-color: var(--background_color);
  }
}
.main-row {
  background-color: var(--background_color);
}
/* ---------- Navbar ---------- */
.navbar {
  background-color: var(--title_red);
}
.nav-link {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.page-title {
  color: #fff;
  font-size: 1.6rem;
  font-family: 'Lucida Grande', helvetica, arial, verdana, sans-serif;
  font-weight: bold;
  text-decoration: none;
  vertical-align: middle;
}
.page-title a {
  color: #fff;
}
.page-title:hover {
  color: #fff;
}
.login-block {
  position: absolute;
  right: 50px;
  top: 10px;
  z-index: 1;
}
#chi {
  display: inline;
  position: relative;
  top: -6px;
}
.top-alert {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 999;
}
/* ------ Bootstrap redefinition --- */
.btn-primary {
  color: var(--btn-primary-color);
  background-color: var(--btn-primary-bg-color);
  border-color: var(--btn-primary-border-color);
}
.btn-primary:hover,
.btn-primary:focus {
  color: var(--btn-primary-color-hover) !important;
  background-color: var(--btn-primary-bg-color-hover) !important;
  border-color: var(--btn-primary-border-color-hover) !important;
}
.nav-pills .nav-link {
  color: var(--navlink-color);
}
.nav-pills .nav-link:hover {
  color: var(--navlink-color-hover);
  background-color: var(--navlink-bg-hover);
}
.nav-pills .nav-link.active {
  background-color: var(--navlink-bg-color) !important;
  color: var(--navlink-color-active) !important;
}
/* ---------- Menu ---------- */
.menu-content {
  background-color: var(--menu_content_bg);
  padding: 0.5rem 1rem 2rem 1rem;
  border-radius: var(--border_curv);
  width: var(--menu_width);
}
.counter {
  color: #aaa;
}
.menu-title {
  font-size: 1.5rem;
  color: var(--menu_title_color);
  margin: 20px 0 5px 0;
}
.menu-item-bm a {
  font-size: 1.2rem;
  color: var(--bm-item-color);
  text-decoration: none;
}
.menu-item-bm a:hover {
  color: var(--bm-item-hover-color);
}
.menu-item label,
.menu-item a,
.menu-item input {
  cursor: pointer;
  text-decoration: none;
  color: var(--menu_item_color);
}
.menu-item label:hover,
.menu-item a:hover,
.menu-item input:hover {
  color: var(--menu_item_hover_color);
}
.paper {
  font-size: 1.1rem;
}
/* ---------- Main content block ---------- */
.paper-wrapper {
  border-radius: var(--border_curv);
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  font-size: 1.2rem;
  background-color: var(--wrap_bg_color);
  color: var(--wrap_color);
  overflow: hidden;
}
.footer {
  color: var(--menu_item_color);
  text-align: center;
  margin: 3rem 3rem 5rem 3rem;
}
.sub-alert {
  color: #f00;
}
.shade {
  opacity: 0.5;
}
.shift {
  padding: 0.25rem 0 2rem 2rem !important;
}
.non-standard-link {
  text-decoration: none;
  color: var(--wrap_color);
}
.non-standard-link:hover {
  text-decoration: none;
  color: var(--wrap_color);
}
.link-under:hover {
  text-decoration: underline;
}
a.disabled {
  /* And disable the pointer events */
  pointer-events: none;
}
.paper-day {
  padding: 0.5rem 1rem;
  border-color: var(--unseen-border-color);
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}
.paper-day:hover {
  background-color: var(--seen-hover-bg);
  text-decoration: none;
}
.unseen {
  background-color: var(--unseen-paper-bg);
}
.paper-day.unseen:hover {
  background-color: var(--unseen-hover-bg) !important;
}
p > a {
  text-decoration: none;
}
p > a:hover {
  text-decoration: underline;
}
.jumb {
  height: 80vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}
.jumb h1 {
  font-weight: 350;
  font-family: Helvetica, "Trebuchet MS", Verdana, sans-serif;
}
.jumb p {
  font-size: 1.1rem;
}
h2 {
  text-align: center;
}
.carousel-dark .carousel-caption {
  color: var(--wrap_color);
}
.down-link a {
  position: absolute;
  top: 75vh;
  padding-top: 70px;
  z-index: 2;
  display: inline-block;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  color: var(--wrap_color);
  font: normal 400 20px/1 'Josefin Sans', sans-serif;
  letter-spacing: 0.1em;
  text-decoration: none;
  transition: opacity 0.3s;
  opacity: 0.7;
}
.down-link a span {
  position: absolute;
  top: 80px;
  left: 50%;
  width: 24px;
  height: 24px;
  margin-left: -12px;
  border-left: 3px solid var(--wrap_color);
  border-bottom: 3px solid var(--wrap_color);
  opacity: 0.7;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-animation: sdb05 1.5s infinite;
  animation: sdb05 1.5s infinite;
  box-sizing: border-box;
}
.down-link a:hover {
  opacity: 0.4;
}
@-webkit-keyframes sdb05 {
  0% {
    -webkit-transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    -webkit-transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}
@keyframes sdb05 {
  0% {
    transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./less/about.less","webpack://./less/layout.less"],"names":[],"mappings":"AAAA,kCAAkC;ACElC;EACE,qKAAA;EACA,6CAAA;ADAF;ACGA;EACE;IACE,yCAAA;EDDF;AACF;ACIA;EACE,yCAAA;ADFF;AACA,iCAAiC;ACKjC;EACE,kCAAA;ADHF;ACMA;EACE,oBAAA;EACA,qBAAA;ADJF;ACOA;EACE,WAAA;EACA,iBAAA;EACA,mEAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;ADLF;ACOE;EACE,WAAA;ADLJ;ACQE;EACE,WAAA;ADNJ;ACUA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;ADRF;ACWA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;ADTF;ACYA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ADVF;AACA,sCAAsC;ACatC;EACE,+BAAA;EACA,6CAAA;EACA,6CAAA;ADXF;ACaE;;EAEE,gDAAA;EACA,8DAAA;EACA,8DAAA;ADXJ;ACeA;EACE,2BAAA;ADbF;ACgBA;EACE,iCAAA;EACA,yCAAA;ADdF;ACiBA;EACE,oDAAA;EACA,6CAAA;ADfF;AACA,+BAA+B;ACmB/B;EACE,wCAAA;EACA,8BAAA;EACA,iCAAA;EACA,wBAAA;ADjBF;ACoBA;EACE,WAAA;ADlBF;ACqBA;EACE,iBAAA;EACA,8BAAA;EACA,oBAAA;ADnBF;ACsBA;EAEI,iBAAA;EACA,2BAAA;EACA,qBAAA;ADrBJ;ACuBI;EACE,iCAAA;ADrBN;AC0BA;;;EAII,eAAA;EACA,qBAAA;EACA,6BAAA;ADzBJ;AC2BI;;;EACE,mCAAA;ADvBN;AC4BA;EACE,iBAAA;AD1BF;AACA,6CAA6C;AC8B7C;EACE,iCAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sCAAA;EACA,wBAAA;EACA,gBAAA;AD5BF;AC+BA;EACE,6BAAA;EACA,kBAAA;EACA,2BAAA;AD7BF;ACgCA;EACE,WAAA;AD9BF;ACiCA;EACE,YAAA;AD/BF;ACkCA;EACE,uCAAA;ADhCF;ACmCA;EACE,qBAAA;EACA,wBAAA;ADjCF;ACmCE;EACE,qBAAA;EACA,wBAAA;ADjCJ;ACsCE;EACE,0BAAA;ADpCJ;ACwCA;EDtCE,mCAAmC;ECwCnC,oBAAA;ADtCF;ACyCA;EACE,oBAAA;EACA,wCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;ADvCF;ACyCE;EACE,sCAAA;EACA,qBAAA;ADvCJ;AC2CA;EACE,wCAAA;ADzCF;AC4CA;EACE,mDAAA;AD1CF;AC6CA;EACE,qBAAA;AD3CF;AC6CE;EACE,0BAAA;AD3CJ;AA/KA;EACE,YAAA;EACA,yDAAA;EACA,sBAAA;AAiLF;AA/KE;EACE,gBAAA;EACA,2DAAA;AAiLJ;AA9KE;EACE,iBAAA;AAgLJ;AA5KA;EACE,kBAAA;AA8KF;AA3KA;EACE,wBAAA;AA6KF;AA1KA;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;EACA,qBAAA;EACA,qCAAA;EACA,6BAAA;EACA,wBAAA;EACA,kDAAA;EACA,qBAAA;EACA,qBAAA;EACA,wBAAA;EACA,YAAA;AA4KF;AA1KE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,0CAAA;EACA,YAAA;EACA,iCAAA;EACA,yBAAA;EACA,sCAAA;EACA,8BAAA;EACA,sBAAA;AA4KJ;AAxKA;EACE,YAAA;AA0KF;AAvKA;EACE;IACE,iDAAA;IACA,UAAA;EAyKF;EAtKA;IACE,UAAA;EAwKF;EArKA;IACE,wDAAA;IACA,UAAA;EAuKF;AACF;AApKA;EACE;IACE,yCAAA;IACA,UAAA;EAsKF;EAnKA;IACE,UAAA;EAqKF;EAlKA;IACE,gDAAA;IACA,UAAA;EAoKF;AACF","sourcesContent":["@import \"layout.less\";\n\n.jumb {\n  height: 80vh;\n  background-image: url(\"../dist/img/lib.jpg\");\n  background-size: cover;\n\n  & h1 {\n    font-weight: 350;\n    font-family: Helvetica, \"Trebuchet MS\", Verdana, sans-serif;\n  }\n\n  & p {\n    font-size: 1.1rem;\n  }\n}\n\nh2 {\n  text-align: center;\n}\n\n.carousel-dark .carousel-caption {\n  color: var(--wrap_color);\n}\n\n.down-link a {\n  position: absolute;\n  top: 75vh;\n  padding-top: 70px;\n  z-index: 2;\n  display: inline-block;\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  color: var(--wrap_color);\n  font: normal 400 20px/1 'Josefin Sans', sans-serif;\n  letter-spacing: 0.1em;\n  text-decoration: none;\n  transition: opacity 0.3s;\n  opacity: 0.7;\n\n  & span {\n    position: absolute;\n    top: 80px;\n    left: 50%;\n    width: 24px;\n    height: 24px;\n    margin-left: -12px;\n    border-left: 3px solid var(--wrap_color);\n    border-bottom: 3px solid var(--wrap_color);\n    opacity: 0.7;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    -webkit-animation: sdb05 1.5s infinite;\n    animation: sdb05 1.5s infinite;\n    box-sizing: border-box;\n  }\n}\n\n.down-link a:hover {\n  opacity: 0.4;\n}\n\n@-webkit-keyframes sdb05 {\n  0% {\n    -webkit-transform: rotate(-45deg) translate(0, 0);\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: rotate(-45deg) translate(-20px, 20px);\n    opacity: 0;\n  }\n}\n\n@keyframes sdb05 {\n  0% {\n    transform: rotate(-45deg) translate(0, 0);\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: rotate(-45deg) translate(-20px, 20px);\n    opacity: 0;\n  }\n}\n","/* ---------- General ---------- */\n\nbody {\n  font-family: BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  background-color: var(--background_color_mob);\n}\n\n@media (min-width: 768px) {\n  body {\n    background-color: var(--background_color);\n  }\n}\n\n.main-row {\n  background-color: var(--background_color);\n}\n\n/* ---------- Navbar ---------- */\n.navbar {\n  background-color: var(--title_red);\n}\n\n.nav-link {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.page-title {\n  color: #fff;\n  font-size: 1.6rem;\n  font-family: 'Lucida Grande', helvetica, arial, verdana, sans-serif;\n  font-weight: bold;\n  text-decoration: none;\n  vertical-align: middle;\n\n  & a {\n    color: #fff;\n  }\n\n  &:hover {\n    color: #fff;\n  }\n}\n\n.login-block {\n  position: absolute;\n  right: 50px;\n  top: 10px;\n  z-index: 1;\n}\n\n#chi {\n  display: inline;\n  position: relative;\n  top: -6px;\n}\n\n.top-alert {\n  position: fixed;\n  top: 70px;\n  left: 0;\n  width: 100%;\n  z-index: 999;\n}\n\n/* ------ Bootstrap redefinition --- */\n.btn-primary {\n  color: var(--btn-primary-color);\n  background-color: var(--btn-primary-bg-color);\n  border-color: var(--btn-primary-border-color);\n\n  &:hover,\n  &:focus {\n    color: var(--btn-primary-color-hover) !important;\n    background-color: var(--btn-primary-bg-color-hover) !important;\n    border-color: var(--btn-primary-border-color-hover) !important;\n  }\n}\n\n.nav-pills .nav-link {\n  color: var(--navlink-color);\n}\n\n.nav-pills .nav-link:hover {\n  color: var(--navlink-color-hover);\n  background-color: var(--navlink-bg-hover);\n}\n\n.nav-pills .nav-link.active {\n  background-color: var(--navlink-bg-color) !important;\n  color: var(--navlink-color-active) !important;\n}\n\n/* ---------- Menu ---------- */\n\n.menu-content {\n  background-color: var(--menu_content_bg);\n  padding: 0.5rem 1rem 2rem 1rem;\n  border-radius: var(--border_curv);\n  width: var(--menu_width);\n}\n\n.counter {\n  color: #aaa;\n}\n\n.menu-title {\n  font-size: 1.5rem;\n  color: var(--menu_title_color);\n  margin: 20px 0 5px 0;\n}\n\n.menu-item-bm {\n  a {\n    font-size: 1.2rem;\n    color: var(--bm-item-color);\n    text-decoration: none;\n\n    &:hover {\n      color: var(--bm-item-hover-color);\n    }\n  }\n}\n\n.menu-item {\n  label,\n  a,\n  input {\n    cursor: pointer;\n    text-decoration: none;\n    color: var(--menu_item_color);\n\n    &:hover {\n      color: var(--menu_item_hover_color);\n    }\n  }\n}\n\n.paper {\n  font-size: 1.1rem;\n}\n\n/* ---------- Main content block ---------- */\n\n.paper-wrapper {\n  border-radius: var(--border_curv);\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  font-size: 1.2rem;\n  background-color: var(--wrap_bg_color);\n  color: var(--wrap_color);\n  overflow: hidden;\n}\n\n.footer {\n  color: var(--menu_item_color);\n  text-align: center;\n  margin: 3rem 3rem 5rem 3rem;\n}\n\n.sub-alert {\n  color: #f00;\n}\n\n.shade {\n  opacity: 0.5;\n}\n\n.shift {\n  padding: 0.25rem 0 2rem 2rem !important;\n}\n\n.non-standard-link {\n  text-decoration: none;\n  color: var(--wrap_color);\n\n  &:hover {\n    text-decoration: none;\n    color: var(--wrap_color);\n  }\n}\n\n.link-under {\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\na.disabled {\n  /* And disable the pointer events */\n  pointer-events: none;\n}\n\n.paper-day {\n  padding: 0.5rem 1rem;\n  border-color: var(--unseen-border-color);\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n\n  &:hover {\n    background-color: var(--seen-hover-bg);\n    text-decoration: none;\n  }\n}\n\n.unseen {\n  background-color: var(--unseen-paper-bg);\n}\n\n.paper-day.unseen:hover {\n  background-color: var(--unseen-hover-bg) !important;\n}\n\np > a {\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
